

// Responsible for detecting unauthorized or not authenticated access.
angular.module('inkfinder')
.factory('AuthInterceptor', function($rootScope, $q, AUTH_EVENTS) {
  return {
    responseError: function(response) {
      $rootScope.$broadcast({
        401: AUTH_EVENTS.notAuthenticated,
        403: AUTH_EVENTS.notAuthorized,
        404: AUTH_EVENTS.notFound
      }[response.status], response);

      return $q.reject(response);
    }
  };
});



// WEBPACK FOOTER //
// ./components/auth/auth-intercept.service.js